//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import VueCropper from 'vue-cropperjs'
import 'cropperjs/dist/cropper.css'
import SecondaryButton from '@/components/shared/secondary-button'
import CloseBtn from '@/components/shared/close-btn'

export default {
  name: 'PhotoJewelryCropper',
  components: {
    VueCropper,
    SecondaryButton,
    CloseBtn
  },

  props: {
    photoJewelry: {},
    productUrl: ''
  },

  data() {
    return {
      valid: false,
      imageToCrop: null,
      sourceImageSrc: '',
      sourceImageFilename: '',
      sourceCropImg: '',
      imageTitle: '',
      imageWidth: 0,
    }
  },
  computed:{
    getAspectRatio(){
      if (this.photoJewelry.aspectRatio != null){
          return  this.photoJewelry.aspectRatio[0]/this.photoJewelry.aspectRatio[1]
      }
      return 1/1;
    }
  },
  methods: {
    setImageToCrop(file) {
      this.$nextTick(() => {
        this.imageToCrop = file
        if (!this.imageToCrop.type.includes('image/')) {
          alert('Please select an image file')
          this.close()
          return
        }
        this.sourceImageFilename = this.imageToCrop.name
        if (typeof FileReader === 'function') {
          this.$store.commit('setLoading', {loading: true})
          try {
            const reader = new FileReader()
            reader.onload = (event) => {
              this.sourceImageSrc = event.target.result
              // rebuild cropperjs with the updated source
              this.$refs.sourceImageCropper.replace(event.target.result)
            }
            reader.readAsDataURL(this.imageToCrop)
          } catch (e) {
            this.$store.commit('setLoading', {loading: false})
          }
        } else {
          alert('Sorry, FileReader API not supported')
        }
      })
    },
    cropImage() {
      // get image data for post processing, e.g. upload or setting image src
      this.sourceCropImg = this.$refs.sourceImageCropper.getCroppedCanvas().toDataURL();
    },
    save() {
      if (this.sourceCropImg) {
        this.$refs.sourceImageCropper.getCroppedCanvas().toBlob((blob) => {
          this.$emit('imageCropped', {
            blob,
            filename: this.sourceImageFilename,
            title: this.imageTitle,
          })
        })
      }
    },
    close() {
      this.$emit('close')
    },
    changesourceImageIconsClick({target}) {
      const action =
          target.getAttribute('data-action') ||
          target.parentElement.getAttribute('data-action')

      switch (action) {
        case 'move':
        case 'crop':
          this.$refs.sourceImageCropper.setDragMode(action)
          break

        case 'zoom-in':
          console.log(this.$refs.sourceImageCropper)
          this.$refs.sourceImageCropper.relativeZoom(0.1)
          break

        case 'zoom-out':
          this.$refs.sourceImageCropper.relativeZoom(-0.1)
          break

        case 'rotate-left':
          this.$refs.sourceImageCropper.rotate(-90)
          break

        case 'rotate-right':
          this.$refs.sourceImageCropper.rotate(90)
          break

        case 'flip-horizontal':
          this.$refs.sourceImageCropper.scaleX(
              -this.$refs.sourceImageCropper.getData().scaleX || -1
          )
          break

        case 'flip-vertical':
          this.$refs.sourceImageCropper.scaleY(
              -this.$refs.sourceImageCropper.getData().scaleY || -1
          )
          break

        default:
      }
      this.cropImage();
    },
    handleResize() {
      const max = 445;
      if (this.$refs.ProductImage.offsetWidth > 0){
        let differencePercentage = (this.$refs.ProductImage.offsetWidth *100)/max;
        let actualLeft = parseInt(this.photoJewelry.left) *differencePercentage /100;
        let actualTop = parseInt(this.photoJewelry.top) *differencePercentage /100;


        this.$refs.CroppedImage.style.left = `${actualLeft}px`;
        this.$refs.CroppedImage.style.top = `${actualTop}px`;

        this.$refs.CroppedImage.style.width = `${parseInt(this.photoJewelry.width)*differencePercentage /100}px`;
        this.$refs.CroppedImage.style.height = `${parseInt(this.photoJewelry.height)*differencePercentage /100}px`;
      }

    },

  },
  mounted() {
     window.addEventListener('resize', this.handleResize);
     this.imageWidth = this.$refs.ProductImage.width;

  },
  updated() {
    if (this.imageWidth !== this.$refs.ProductImage.width) {
      this.handleResize();
      this.imageWidth = this.$refs.ProductImage.width;
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
}
